// Defaree theme — interactions: drawers, AJAX cart, product form, gallery, carousels.
(function () {
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];
  const routes = window.DEFAREE.routes;

  // ---------- Drawers ----------
  const overlay = $("#overlay");
  function openDrawer(id) {
    const d = document.getElementById(id);
    if (!d) return;
    d.classList.add("is-open");
    d.setAttribute("aria-hidden", "false");
    overlay.classList.add("is-open");
    document.body.style.overflow = "hidden";
  }
  function closeDrawers() {
    $$(".drawer").forEach((d) => { d.classList.remove("is-open"); d.setAttribute("aria-hidden", "true"); });
    overlay.classList.remove("is-open");
    document.body.style.overflow = "";
  }
  document.addEventListener("click", (e) => {
    const opener = e.target.closest("[data-open-drawer]");
    if (opener) { e.preventDefault(); openDrawer(opener.dataset.openDrawer); }
    if (e.target.closest("[data-close]") || e.target === overlay) closeDrawers();
    if (e.target.closest("#menuDrawer a")) closeDrawers();
  });
  document.addEventListener("keydown", (e) => e.key === "Escape" && closeDrawers());

  // ---------- Cart (Shopify AJAX API + Section Rendering API) ----------
  async function refreshCart() {
    const res = await fetch(`${routes.cart}?sections=cart-drawer`);
    const data = await res.json();
    const html = new DOMParser().parseFromString(data["cart-drawer"], "text/html");
    // Read the count before replaceWith() moves the fresh node out of `html`
    const count = $("[data-cart-count-source]", html)?.textContent.trim() || "0";
    const fresh = $("#cartDrawerContent", html);
    if (fresh) $("#cartDrawerContent").replaceWith(fresh);
    $$("[data-cart-count]").forEach((el) => (el.textContent = count));
  }
  // Resolves once an AddToCart tracking request has completed, or after `max` ms.
  function waitForTracking(max) {
    return new Promise((resolve) => {
      const isAtc = (name) => /multi-pixels\.com\/scriptall.*AddToCart|facebook\.com\/tr.*ev=AddToCart/.test(name);
      let po;
      const done = () => { if (po) po.disconnect(); clearTimeout(timer); setTimeout(resolve, 50); };
      const timer = setTimeout(done, max);
      if (performance.getEntriesByType("resource").some((e) => isAtc(e.name) && e.startTime > (window.__atcClickAt || 0))) return done();
      try {
        po = new PerformanceObserver((list) => { if (list.getEntries().some((e) => isAtc(e.name))) done(); });
        po.observe({ type: "resource", buffered: false });
      } catch (e) { /* older browsers: the timeout still applies */ }
    });
  }
  async function addToCart(body, options = {}) {
    const res = await fetch(`${routes.cartAdd}.js`, {
      method: "POST",
      headers: { Accept: "application/json", "X-Requested-With": "XMLHttpRequest", ...(body instanceof FormData ? {} : { "Content-Type": "application/json" }) },
      body: body instanceof FormData ? body : JSON.stringify(body),
    });
    const json = await res.json();
    if (!res.ok) throw new Error(json.description || json.message || "Could not add to cart");
    if (options.redirect) {
      // Give tracking apps (Meta pixel / Pixelfy server events) time to report the AddToCart before leaving the page
      await waitForTracking(1500);
      window.location.href = options.redirect;
      return;
    }
    await refreshCart();
    openDrawer("cartDrawer");
  }
  async function changeLine(line, quantity) {
    const drawer = $("#cartDrawerContent");
    drawer.classList.add("is-loading");
    await fetch(`${routes.cartChange}.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ line, quantity }),
    });
    await refreshCart();
  }
  document.addEventListener("click", async (e) => {
    const q = e.target.closest("[data-line]");
    if (q) { e.preventDefault(); changeLine(+q.dataset.line, +q.dataset.qty); }
    const up = e.target.closest("[data-add-variant]");
    if (up) {
      e.preventDefault();
      up.classList.add("is-loading");
      try { await addToCart({ items: [{ id: +up.dataset.addVariant, quantity: 1 }] }); } catch (err) { alert(err.message); }
      up.classList.remove("is-loading");
    }
  });

  // ---------- Product form ----------
  $$("[data-product-form]").forEach((form) => {
    const error = $(".product-form__error", form);
    form.addEventListener("submit", async (e) => {
      e.preventDefault();
      const buttons = $$(`[type=submit][form="${form.id}"], [type=submit]`, document).filter((b) => b.form === form);
      buttons.forEach((b) => b.classList.add("is-loading"));
      if (error) error.textContent = "";
      // "Buy now" mode: the checkout holds exactly the chosen pack (no duplicate if the shopper came back)
      const toCheckout = form.dataset.afterAdd === "checkout";
      window.__atcClickAt = performance.now();
      try {
        if (toCheckout) await fetch(`${routes.cartClear || "/cart/clear"}.js`, { method: "POST", headers: { Accept: "application/json" } });
        await addToCart(new FormData(form), toCheckout ? { redirect: "/checkout" } : {});
        if (toCheckout) return; // keep the loading state while the browser leaves the page
      }
      catch (err) { if (error) error.textContent = err.message; }
      buttons.forEach((b) => b.classList.remove("is-loading"));
    });

    // Supply (variant) selection
    form.addEventListener("change", (e) => {
      const input = e.target.closest('input[name="id"]');
      if (!input) return;
      $$(".supply", form).forEach((l) => l.classList.toggle("is-active", l.contains(input)));
      const price = input.dataset.price, compare = input.dataset.compare;
      $$("[data-cta-price]").forEach((el) => (el.innerHTML = price + (compare ? ` <s>${compare}</s>` : "")));
      $$("[data-sticky-variant]").forEach((el) => (el.textContent = `${input.dataset.title} · ${price}`));
      if (input.dataset.media) showSlide($(`.gallery__slide[data-media-id="${input.dataset.media}"]`));
    });
  });

  // ---------- Gallery ----------
  function showSlide(slide) {
    if (!slide) return;
    const index = $$(".gallery__slide").indexOf(slide);
    $$(".gallery__slide").forEach((s) => {
      s.classList.toggle("is-active", s === slide);
      // Only the visible slide plays; others pause to save battery and data
      const v = $("video", s);
      if (v) { if (s === slide) { v.muted = true; v.play().catch(() => {}); } else v.pause(); }
    });
    $$(".gallery__thumbs button").forEach((b, i) => b.classList.toggle("is-active", i === index));
  }
  document.addEventListener("click", (e) => {
    const t = e.target.closest(".gallery__thumbs button");
    if (t) showSlide($$(".gallery__slide")[+t.dataset.index]);
  });

  // ---------- Trust bar ----------
  $$("[data-trust-bar]").forEach((bar) => {
    const items = $$(".trust-bar__track span", bar);
    if (items.length < 2) return;
    let i = 0;
    const show = (d) => { items[i].classList.remove("is-active"); i = (i + d + items.length) % items.length; items[i].classList.add("is-active"); };
    $$("[data-trust]", bar).forEach((b) => b.addEventListener("click", () => show(+b.dataset.trust)));
    setInterval(() => show(1), 4000);
  });

  // ---------- Carousels ----------
  $$("[data-carousel]").forEach((c) => {
    const track = $(".carousel__track", c);
    $(".prev", c)?.addEventListener("click", () => track.scrollBy({ left: -track.clientWidth / 2, behavior: "smooth" }));
    $(".next", c)?.addEventListener("click", () => track.scrollBy({ left: track.clientWidth / 2, behavior: "smooth" }));
  });

  // ---------- Show more (experts) ----------
  document.addEventListener("click", (e) => {
    const b = e.target.closest("[data-show-more]");
    if (!b) return;
    $$(".is-hidden", b.closest("section")).forEach((x) => x.classList.remove("is-hidden"));
    b.remove();
  });

  // ---------- Stat counters ----------
  const io = new IntersectionObserver((entries) => {
    entries.forEach((en) => {
      if (!en.isIntersecting) return;
      const el = en.target, target = +el.dataset.count;
      let n = 0;
      const tick = () => { n = Math.min(target, n + Math.max(1, Math.round(target / 45))); el.textContent = n; if (n < target) requestAnimationFrame(tick); };
      tick();
      io.unobserve(el);
    });
  }, { threshold: 0.5 });
  $$("[data-count]").forEach((el) => io.observe(el));

  // ---------- Sticky add-to-cart (mobile) ----------
  const atc = $("[data-main-atc]"), sticky = $("#stickyAtc");
  if (atc && sticky) {
    // Show the bar as soon as the shopper scrolls past the first screen, except while the main button is on screen
    let atcInView = false;
    const update = () => sticky.classList.toggle("is-visible", !atcInView && window.scrollY > window.innerHeight * 0.6);
    new IntersectionObserver(([en]) => { atcInView = en.isIntersecting; update(); }).observe(atc);
    window.addEventListener("scroll", update, { passive: true });
  }

  // ---------- Localization selectors ----------
  document.addEventListener("change", (e) => {
    if (e.target.matches("[data-localization-select]")) e.target.form.submit();
  });
})();

// Looping videos: play only when on screen (saves battery/data), respect reduced motion.
(function () {
  const videos = document.querySelectorAll("video.loop-video");
  if (!videos.length) return;
  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const io = new IntersectionObserver((entries) => {
    entries.forEach(({ target, isIntersecting }) => {
      if (isIntersecting && !reduce) target.play().catch(() => {});
      else target.pause();
    });
  }, { threshold: 0.25 });
  videos.forEach((v) => { v.muted = true; if (reduce) v.removeAttribute("autoplay"); io.observe(v); });
})();

// Carousel auto-scroll: one card every N seconds, pauses on interaction, only while visible.
(function () {
  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (reduce) return;
  document.querySelectorAll("[data-carousel][data-autoplay]").forEach((carousel) => {
    const track = carousel.querySelector(".carousel__track");
    if (!track || track.children.length < 2) return;
    const mode = carousel.dataset.autoplay;
    const delay = (parseInt(carousel.dataset.autoplaySpeed, 10) || 4) * 1000;
    const RESUME_AFTER = 6000;
    let timer = null, visible = false, pausedUntil = 0;

    const breakpoint = parseInt(carousel.dataset.autoplayBreakpoint, 10) || 900;
    const enabledForViewport = () => mode === "all" || window.matchMedia(`(max-width: ${breakpoint}px)`).matches;

    function step() {
      if (!visible || document.hidden || Date.now() < pausedUntil || !enabledForViewport()) return;
      const card = track.children[0];
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      const stride = card.getBoundingClientRect().width + gap;
      const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      track.scrollTo({ left: atEnd ? 0 : track.scrollLeft + stride, behavior: "smooth" });
    }
    const start = () => { if (!timer) timer = setInterval(step, delay); };
    const stop = () => { clearInterval(timer); timer = null; };
    const pause = () => { pausedUntil = Date.now() + RESUME_AFTER; };

    ["pointerdown", "touchstart", "wheel", "focusin"].forEach((ev) => track.addEventListener(ev, pause, { passive: true }));
    carousel.querySelectorAll(".carousel__btn").forEach((b) => b.addEventListener("click", pause));

    new IntersectionObserver(([en]) => {
      visible = en.isIntersecting;
      visible ? start() : stop();
    }, { threshold: 0.4 }).observe(carousel);
  });
})();

// Cart drawer suggestions: "next" arrow (delegated, survives drawer re-renders)
document.addEventListener("click", (e) => {
  const btn = e.target.closest("[data-scroll-next]");
  if (!btn) return;
  const track = btn.parentElement.querySelector("[data-scroll-track]");
  if (!track) return;
  const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
  track.scrollTo({ left: atEnd ? 0 : track.scrollLeft + track.clientWidth * 0.92, behavior: "smooth" });
});

// Sticky add-to-cart dropdown <-> main supply selector (two-way sync)
document.querySelectorAll("[data-sticky-select]").forEach((select) => {
  const form = document.getElementById(select.dataset.formId);
  if (!form) return;
  select.addEventListener("change", () => {
    const radio = form.querySelector(`input[name="id"][value="${select.value}"]`);
    if (radio && !radio.checked) {
      radio.checked = true;
      radio.dispatchEvent(new Event("change", { bubbles: true }));
    }
  });
  form.addEventListener("change", (e) => {
    if (e.target.matches('input[name="id"]') && select.value !== e.target.value) select.value = e.target.value;
  });
});

// Sale countdown: fills [data-sale-end] badges, removes them (and an empty sale callout timer) once the sale ends.
(() => {
  const timers = document.querySelectorAll("[data-sale-end]");
  if (!timers.length) return;
  const pad = (n) => String(n).padStart(2, "0");
  const tick = () => {
    const now = new Date();
    timers.forEach((el) => {
      const end = new Date(el.dataset.saleEnd);
      const ms = end - now;
      if (isNaN(ms) || ms <= 0) { el.hidden = true; return; }
      const s = Math.floor(ms / 1000);
      const clock = `${pad(Math.floor(s / 3600) % 24)}:${pad(Math.floor(s / 60) % 60)}:${pad(s % 60)}`;
      const days = Math.floor(s / 86400);
      const lastDay = end.toDateString() === now.toDateString();
      el.textContent = lastDay ? ` · ${el.dataset.tonight} ${clock}` : ` · ${el.dataset.ends} ${days > 0 ? days + "d " : ""}${clock}`;
      el.hidden = false;
    });
  };
  tick();
  setInterval(tick, 1000);
})();
